export const CUSTOM_EVENT = {
  GAME_RELOAD: 'GAME_RELOAD',
  CVV_GUIDANCE: 'CVV_GUIDANCE',
}
